module.exports = __webpack_public_path__ + "media/honey-icons/icon-hive-circle-2f46c721.svg";